var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "languages",
      class: { active: _vm.dropdownIsOpen },
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _vm.activeLanguage
        ? _c(
            "a",
            {
              staticClass: "languages__current",
              attrs: { href: "javascript:;" },
              on: {
                click: function($event) {
                  _vm.dropdownIsOpen = !_vm.dropdownIsOpen
                }
              }
            },
            [
              _c("fa-icon", { attrs: { icon: ["fal", "globe"] } }),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.activeLanguage.locale) +
                  "\n        "
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "languages__options" },
        _vm._l(_vm.languages, function(language) {
          return _c(
            "li",
            {
              key: language.id,
              class: { active: _vm.activeLanguage.id == language.id }
            },
            [
              _vm.activeLanguage.id == language.id
                ? _c("span", [_vm._v(_vm._s(language.name))])
                : _vm.$route.meta.alternateLanguages &&
                  _vm.$route.meta.alternateLanguages[language.locale]
                ? _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "/" +
                          _vm.$route.meta.alternateLanguages[language.locale]
                      }
                    },
                    [_vm._v(_vm._s(language.name) + "\n            ")]
                  )
                : _c("a", { attrs: { href: "/" + language.locale } }, [
                    _vm._v(_vm._s(language.name) + "\n            ")
                  ])
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cfe9d3de", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfe9d3de","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../default-js/js/components/common/LanguageSwitch.vue
// module id = 238
// module chunks = 17